// shared/services/permissions.mjs
//
// PermissionService — resolves and caches a user's permission set per
// (orgId, roleKey). Usable from both browser (Firebase SDK) and Node
// (Firebase Admin SDK) by passing in the appropriate getDoc / doc primitives.
//
// IMPORTANT: This is for UX gating (show/hide buttons). The authoritative
// permission check is at the Firestore rule layer. Never trust client cache
// state for security decisions.

export class PermissionService {
  constructor(db, getDoc, doc) {
    this.db = db;
    this.getDoc = getDoc;
    this.doc = doc;
    this.cache = new Map();
  }

  async resolvePermissions(orgId, roleKey) {
    const cacheKey = `${orgId}:${roleKey}`;
    if (this.cache.has(cacheKey)) return this.cache.get(cacheKey);

    const snap = await this.getDoc(this.doc(this.db, `organizations/${orgId}/roles/${roleKey}`));
    const perms = new Set(
      snap.exists() ? (snap.data().permissions || []) : []
    );
    this.cache.set(cacheKey, perms);
    return perms;
  }

  invalidate(orgId) {
    if (orgId) {
      for (const k of [...this.cache.keys()]) {
        if (k.startsWith(`${orgId}:`)) this.cache.delete(k);
      }
    } else {
      this.cache.clear();
    }
  }
}
